/* Fit only the active mobile menu to its existing, preview-aware viewport.
   No scaling, hidden links, font reduction, or change to native menu actions. */
(() => {
  'use strict';
  if (window.uraMobileMenuFitV1) { window.uraMobileMenuFitV1.scan(); return; }
  const mobile = matchMedia('(max-width:760px)');
  const bindings = new Map();
  const profiles = ['relaxed', 'compact', 'tight'];
  const number = value => Number.parseFloat(value) || 0;

  function bind(menu) {
    if (bindings.has(menu)) return;
    const viewport = menu.querySelector('.ura-index__viewport');
    const content = menu.querySelector('.ura-shop-menu');
    if (!viewport || !content) return;
    const events = new AbortController();
    const options = {signal:events.signal};
    let queued = false, disposed = false;
    const set = (key, value) => {
      if (menu.getAttribute(key) !== value) menu.setAttribute(key, value);
    };
    const fit = () => {
      queued = false;
      if (disposed || !menu.isConnected) return;
      if (!mobile.matches) {
        ['data-ura-mobile-menu-fit','data-ura-menu-density','data-ura-menu-fit-result'].forEach(key => menu.removeAttribute(key));
        return;
      }
      set('data-ura-mobile-menu-fit', 'v1');
      if (!menu.hasAttribute('data-ura-menu-density')) set('data-ura-menu-density', 'relaxed');
      if (menu.hidden || !menu.getClientRects().length) return;
      // Let expanded content and the native account/search flows scroll normally.
      if (menu.classList.contains('is-heritage-open') ||
          document.documentElement.classList.contains('ura-account-sheet-open') ||
          (window.visualViewport?.scale || 1) > 1.05 ||
          viewport.contains(document.activeElement) && document.activeElement.matches('input,textarea,[contenteditable="true"]')) {
        set('data-ura-menu-fit-result', 'interactive-scroll');
        return;
      }
      const menuStyle = getComputedStyle(menu);
      const viewportStyle = getComputedStyle(viewport);
      const border = number(menuStyle.borderTopWidth) + number(menuStyle.borderBottomWidth);
      const panelLimit = number(menuStyle.getPropertyValue('--ura-panel-height')) || number(menuStyle.maxHeight);
      const viewportLimit = number(viewportStyle.maxHeight);
      const capacity = Math.min(panelLimit - border, viewportLimit || panelLimit - border);
      if (!(capacity > 0)) return;
      // Three bounded layout reads in one microtask, before the open frame paints.
      let fits = false;
      for (const profile of profiles) {
        set('data-ura-menu-density', profile);
        fits = viewport.scrollHeight <= capacity + 0.5;
        if (fits) break;
      }
      set('data-ura-menu-fit-result', fits ? 'all-visible' : 'scroll-fallback');
    };
    const queue = () => {
      if (queued || disposed) return;
      queued = true;
      Promise.resolve().then(fit);
    };
    // Only native state/geometry attributes, never attributes written by this fitter.
    const state = new MutationObserver(queue);
    state.observe(menu, {attributes:true, attributeFilter:['hidden','class','style']});
    const tree = new MutationObserver(queue);
    tree.observe(content, {childList:true, subtree:true});
    mobile.addEventListener('change', queue, options);
    window.addEventListener('resize', queue, {...options, passive:true});
    window.addEventListener('pageshow', queue, options);
    window.visualViewport?.addEventListener('resize', queue, {...options, passive:true});
    menu.addEventListener('focusout', queue, options);
    document.fonts?.addEventListener('loadingdone', queue, options);
    document.fonts?.ready.then(queue);
    bindings.set(menu, () => {
      disposed = true; events.abort(); state.disconnect(); tree.disconnect(); bindings.delete(menu);
    });
    fit();
  }
  function scan() {
    for (const [menu, cleanup] of bindings) if (!menu.isConnected) cleanup();
    const menu = document.getElementById('ura-index');
    if (menu) bind(menu);
  }
  window.uraMobileMenuFitV1 = {scan};
  scan();
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:section:unload', event => {
    for (const [menu, cleanup] of bindings) if (event.target.contains(menu)) cleanup();
  });
})();
